require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.for-each");

require("core-js/modules/web.dom-collections.for-each");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vant/es/dialog/style", "vant/es/dialog", "vant/es/toast/style", "vant/es/toast", "@/utils/time"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vant/es/dialog/style"), require("vant/es/dialog"), require("vant/es/toast/style"), require("vant/es/toast"), require("@/utils/time"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.style, global.dialog, global.style, global.toast, global.time);
    global.outBoundInfo = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _style, _dialog, _style2, _toast, _time) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-product-tool/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _dialog = _interopRequireDefault(_dialog);
  _toast = _interopRequireDefault(_toast);
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var _default = {
    name: 'OutBoundInfo',
    filters: {
      formateTime: _time.formateTime
    },
    data: function data() {
      return {
        selectItem: {},
        expressDeliveryInfo: []
      };
    },
    created: function created() {
      this.initInfo();
    },
    methods: {
      initInfo: function initInfo() {
        var _this = this;

        // 初始化出库详情信息
        var vm = this;
        var ossHostPond = this.$config.base.ossHostPond;
        var item = {};

        if (this.$route.params.item) {
          item = this.$route.params.item;
          item.deviceCountList.forEach(function (item) {
            item.url = "".concat(ossHostPond, "img/").concat(_this.$strTool.getDeviceType(item.deviceType).url);
          });
          vm.$localStorage.setItem('outBoundItem', item);
        } else {
          item = vm.$localStorage.getItem('outBoundItem');
        }

        this.selectItem = item;
        vm.getExpressDeliveryInfo();
      },
      // 获取物流信息
      getExpressDeliveryInfo: function getExpressDeliveryInfo() {
        var vm = this;
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.MP_WECHAT_BASE_URL, "erpFactory/trackingInfo"),
          params: {
            password: vm.$config.base.wechatPassword,
            wayBillNumber: vm.selectItem.platformTrackNum,
            companyCode: vm.selectItem.platformTrackCompanyCode,
            phone: vm.selectItem.platformTrackSendPhone
          }
        }).then(function (res) {
          vm.expressDeliveryInfo = res.data.data || [];
        });
      },
      copyBtn: function copyBtn(text) {
        // 创建临时textarea元素
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        document.body.appendChild(textarea);
        textarea.select();

        try {
          var successful = document.execCommand('copy');

          _toast.default.success({
            message: successful ? '复制成功' : '复制失败',
            forbidClick: false,
            overlay: true,
            duration: 2000
          });
        } catch (err) {
          this.$toast('复制失败');

          _toast.default.success({
            message: '复制失败',
            forbidClick: false,
            overlay: true,
            duration: 2000
          });
        }

        document.body.removeChild(textarea);
      },
      onclickViewAll: function onclickViewAll() {
        this.$router.push({
          name: "SalesRecords",
          params: {
            expressDeliveryInfo: this.expressDeliveryInfo
          }
        });
      },
      // 确认签收按钮
      signForBtn: function signForBtn() {
        var _this2 = this;

        var vm = this;

        _dialog.default.confirm({
          title: "是否确认签收",
          message: "请确认收到的设备类型和数量无误"
        }).then(function () {
          vm.$http({
            type: "put",
            url: "".concat(vm.$config.base.MP_WECHAT_BASE_URL, "erpFactory/getOutbound"),
            params: {
              password: vm.$config.base.wechatPassword,
              outboundId: vm.selectItem.id,
              factoryType: vm.selectItem.factoryType,
              factoryConfirmedName: vm.$localStorage.getItem('userName')
            }
          }).then(function (res) {
            if (res.code == 1) {
              _toast.default.success({
                message: '签收成功',
                forbidClick: false,
                overlay: true,
                duration: 2000
              });

              setTimeout(function () {
                _this2.$router.back();
              }, 2000);
            } else {
              _toast.default.fail({
                message: res.msg || '签收失败',
                forbidClick: false,
                overlay: true,
                duration: 2000
              });
            }
          });
        }).catch(function () {// 用户点击取消
        });
      }
    }
  };
  _exports.default = _default;
});